<template>
  <div class="register-container">
    <img
      class="logo-cover"
      style="width: 150px"
      :src="require('../../assets/img/logo.png')"
    />
    <div class="slider slider1" v-if="slider == 'slider1'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li class="active"></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider2" v-if="slider == 'slider2'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li>
          <li class="active"></li>
          <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider3" v-if="slider == 'slider3'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li>
          <li></li>
          <li class="active"></li>
        </ul>
      </div>
    </div>

    <div class="form-side">
      <p class="alt-text">
        Have an account?
        <router-link class="signup-link" to="/auth/login">Sign In</router-link>
      </p>
      <div class="register-form">
        <div class="form-box">
          <div class="main-form-box">
            <div class="styled-header"></div>
            <form class="form-container" @submit="submitForm">
              <h3>Create Account</h3>
              <p>Let’s get you started! This will only take a few minutes</p>

              <div class="input-box">
                <input
                  type="text"
                  v-bind:class="['input', formErrors.firstname ? 'error' : '']"
                  v-model="regParams.firstname"
                  placeholder="First name"
                  required
                />
                <small v-if="formErrors.firstname" class="error">
                  {{ formErrors.firstname }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="text"
                  v-bind:class="['input', formErrors.lastname ? 'error' : '']"
                  placeholder="Last name"
                  v-model="regParams.lastname"
                  required
                />
                <small v-if="formErrors.lastname" class="error">
                  {{ formErrors.lastname }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="text"
                  v-bind:class="[
                    'input',
                    formErrors.phonenumber ? 'error' : ''
                  ]"
                  placeholder="Phone Number"
                  v-model="regParams.phonenumber"
                  required
                />
                <small v-if="formErrors.phonenumber" class="error">
                  {{ formErrors.phonenumber }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="email"
                  v-bind:class="['input', formErrors.email ? 'error' : '']"
                  placeholder="Email Address"
                  v-model="regParams.email"
                  required
                />
                <small v-if="formErrors.email" class="error">
                  {{ formErrors.email }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="password"
                  v-bind:class="['input', formErrors.password ? 'error' : '']"
                  placeholder="Password"
                  v-model="regParams.password"
                  required
                />
                <small v-if="formErrors.password" class="error">
                  {{ formErrors.password }}
                </small>
              </div>
              <div class="input-box">
                <input
                  type="password"
                  v-bind:class="['input', formErrors.cpassword ? 'error' : '']"
                  placeholder="Confirm Password"
                  v-model="regParams.cpassword"
                  required
                />
                <small v-if="formErrors.cpassword" class="error">
                  {{ formErrors.cpassword }}
                </small>
              </div>

              <button v-if="loader" class="form-button">
                <div class="submit-gif">
                  <div
                    class="spinner-border"
                    style="width: 2rem; height: 2rem"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
              <button @click="submitForm" v-else class="form-button">
                Sign up
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import ArnergyLoader from "./kitchen/ArnergyLoader";
import ArnergyFormInput from "./kitchen/ArnergyFormInput";
import router from "../../router";

export default {
  name: "register",
  components: {
    ArnergyLoader,
    ArnergyFormInput
  },
  data() {
    return {
      bgColor: "../../assets/img/bg-image.jpg",
      regParams: {
        firstname: null,
        lastname: null,
        phonenumber: null,
        username: null,
        email: null,
        password: null,
        cpassword: null
      },
      customerEmail: "",
      slider: "slider1",
      sliderCount: 1,
      mailSent: false,
      formErrors: [],
      loader: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    ...mapActions(["setUserSession", "setAccess"]),
    validateReg() {
      const formErrors = [];

      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "firstname":
            if (value === "null" || value === "") {
              formErrors[field] = "firstname cannot be empty.";
            }
            break;
          case "lastname":
            if (value === "null" || value === "") {
              formErrors[field] = "lastname cannot be empty.";
            }
            break;
          case "email":
            if (value === "null" || value === "") {
              formErrors[field] = "Email cannot be empty.";
            } else if (!this.isEmail(value)) {
              formErrors[field] = "Not a valid email.";
            }
            break;
          case "cemail":
            if (value !== "null" || value !== "") {
              if (value !== this.regParams.email) {
                formErrors[field] = "Emails did not match.";
              }
            }
            break;
          case "password":
            if (value === "null" || value === "") {
              formErrors[field] = "Password cannot be empty.";
            }
            break;
          case "cpassword":
            if (value !== "null" || value !== "") {
              if (value !== this.regParams.password) {
                formErrors[field] = "Password did not match.";
              }
            }
            break;
          case "phonenumber":
            if (value === "null" || value === "") {
              formErrors[field] = "Phone cannot be empty.";
            }
            break;
          case "customerType":
            if (value === "null" || value === "") {
              formErrors[field] = "Please select a Customer type.";
            }
            break;
          case "businessAddress":
            if (
              this.regParams.customerType == "Corporate" &&
              (value === "null" || value === "")
            ) {
              formErrors[field] = "Business Address cannot be empty.";
            }
            break;
          case "businessName":
            if (
              this.regParams.customerType == "Corporate" &&
              (value === "null" || value === "")
            ) {
              formErrors[field] = "Business Name cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    async submitForm(e) {
      e.preventDefault();
      this.formErrors = this.validateReg();
      if (Object.keys(this.formErrors).length > 0) return;

      const data = {
        ...this.regParams,
        roletype: this.regParams.customerType,
        dateofbirth: new Date(),
        wallet: 0,
        realm: "",
        username: this.regParams.email,
        ccemails: this.regParams.email
      };

      var str = JSON.stringify(data);
      const tempReg = JSON.parse(str);

      console.log(tempReg);

      const HTTP = this.$httpUtils.FASTHTTP;

      try {
        this.loader = true;
        let res = await HTTP.post("/auth/register-otp", tempReg)
          .then(res => {
            console.log(res);
            if (res.data) {
              this.loader = false;
              this.mailSent = true;
              this.customerEmail = this.regParams.email;
              this.regParams = {};
              this.$router.push({ name: "EmailVerified", params: res.data });
            }
          })
          .catch(error => {
            // let { response } = error;
            const message = error.response.data.detail;
            this.showErrorMsg({ message: message });
            this.loader = false;
          });
      } catch (error) {
        this.errorMessage = "Something went wrong, please try again.";
        this.showErrorMsg({ message: this.errorMessage });
        this.loader = false;
      }
    }
  },
  mounted() {
    setInterval(() => {
      this.slider = `slider${this.sliderCount}`;
      if (this.sliderCount === 3) this.sliderCount = 1;
      else this.sliderCount++;
    }, 3000);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_reduced_variables.scss";

* {
  transition: 0.3ms ease-in-out;
}

h3,
p,
label,
ul,
li {
  margin: 0;
}

.register-container {
  width: 100%;
  background-color: white;
  display: flex;
}

.slider1 {
  background-image: url("../../assets/img/bg-image.jpg");
  transition: 1ms ease-in-out;
}

.slider2 {
  background-image: url("../../assets/img/slider-image-2.jpg");
  transition: 1ms ease-in-out;
}

.slider3 {
  background-image: url("../../assets/img/slider-image-3.jpg");
  transition: 1ms ease-in-out;
}

.slider {
  width: 60%;
  height: 100vh;
  padding-bottom: 4.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

img.logo-cover {
  position: absolute;
  top: 3.75rem;
  left: 3.75rem;
  z-index: 1;
}

.slider-base {
  width: 53%;
  text-align: center;
}

.slider-text > h3 {
  font-size: 1.5rem/2.5.5rem;
  margin-bottom: 0.625rem;
}

.slider-text > p {
  font-size: 1rem/1.5rem;
  margin-bottom: 2rem;
}

.slider-state {
  list-style-type: none;
  display: flex;
  width: fit-content;
  margin: 0 auto;
}

.slider-state li {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-right: 0.625rem;
  background-color: #dddddd;
  opacity: 0.5;
}

.slider-state li:last-child {
  margin-right: 0rem;
}

.slider-state li.active {
  width: 1.375rem;
  border-radius: 0.31rem;
  background-color: white;
}

.form-side {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex: 1;
  padding: 6rem 9rem;
}

.register-form {
  color: #727272;
}

.form-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alt-text {
  font-size: 1.125rem/1.5rem;
  color: #727272;
  margin-left: auto;
  margin-bottom: 3.5rem;
}

.signup-link {
  color: #fe7a11;
}

.main-form-box {
  width: 100%;
}

.form-container {
  border-radius: 1.875rem 1.875rem 0rem 0rem;
  border: 0.1rem solid rgba(221, 221, 221, 0.5);
  width: 100%;
  height: fit-content;
  box-shadow: 0px 1.2rem 1.6rem rgba(16, 24, 40, 0.1),
    0px 0.4rem 0.6rem rgba(16, 24, 40, 0.05);
  padding: 3rem 7rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.form-container > h3 {
  font-weight: 700;
  font-size: 24px;
  line-height: 38.9px;
  color: #000000;
}

.form-container > p {
  font-size: 1.125rem/1.5rem;
  margin-bottom: 2.5rem;
  line-height: 24px;
}

.input-box {
  position: relative;
  margin-bottom: 1.8rem;
  width: 100%;
}

.input-box:last-child {
  margin-bottom: 0rem;
  background-color: #727272;
}

.input-box input {
  width: 100%;
  border: 1px solid rgba(221, 221, 221, 0.5);
  padding: 14px 22px;
  height: 52px;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.5rem;
  color: #000000;
}

.input-box input:focus {
  border: 1px solid #0892d0;
}

.input-box input.error {
  border: 1px solid #f83c1e;
}

.input-box input::placeholder {
  color: #727272;
}

small.error {
  color: #f83c1e;
}

.input-box label {
  font-size: 16px;
  font-weight: 100;
  position: absolute;
  top: 1.5rem;
  left: 22px;
  color: #727272;
}

.form-button {
  padding: 0.875rem 3rem;
  border-radius: 5px;
  background-color: #0892d0;
  border: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  margin-top: 2.5rem;
  align-self: flex-end;
}

.form-button:hover {
  transform: scale(0.95);
}

.form-loader {
  align-self: flex-end;
}

.submit-gif {
  color: #ffffff;
  text-align: center;
  border: 0;
  background-color: transparent;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  width: 40%;
  max-width: 480px;
  margin: 105px auto;
  padding: 45px;
  background: #ffffff;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  font-family: "DM Sans";
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image {
  margin: 36px auto;
  width: 120px;
}

.logo {
  width: 125px;
}

b {
  font-weight: bold;
  font-family: inherit;
}

.submit-button {
  background: #0892d0;
  border-radius: 5px;
  width: 207px;
  height: 51px;
  margin: 31px auto;
  border: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
}

.close {
  margin: 0px 0px 0px auto;
}

.text {
  width: 90%;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  color: #727272;
  line-height: 24px;
}

.title {
  font-family: inherit;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
}

.max {
  background: rgba(233, 233, 233, 0.83);
}

@media (max-width: 1100px) {
  .register-container {
    width: 100%;
    height: 100vh;
    background-color: white;
  }
  .slider {
    display: none;
  }

  .form-side {
    padding: 8px !important;
    overflow: hidden !important;
    background: white;
    margin: auto;
  }

  .form-container {
    padding: 2rem !important;
    width: 100%;
    background: white;
  }

  .slider-base {
    width: 80% !important;
  }

  .alt-text,
  .form-container,
  .slider-text > h3,
  .slider-text > p,
  .form-container > h3,
  .form-container > p,
  .input-box input::placeholder {
    font-size: 10px !important;
    margin-bottom: 8px !important;
  }

  .input-box input {
    height: 40px !important;
  }

  .alt-text {
    margin-top: 5px !important;
  }

  .form-container > h3 {
    margin: auto;
  }

  .form-button {
    font-size: 10px;
    line-height: 18px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Register.vue